import { render, staticRenderFns } from "./BlockPaymentPackage.vue?vue&type=template&id=762dbdec&scoped=true&"
import script from "./BlockPaymentPackage.vue?vue&type=script&lang=ts&"
export * from "./BlockPaymentPackage.vue?vue&type=script&lang=ts&"
import style0 from "./BlockPaymentPackage.vue?vue&type=style&index=0&id=762dbdec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762dbdec",
  null
  
)

export default component.exports